import { MarkdownRenderer } from '@components/markdown-renderer';
import MED_INFO_CONTENT from '@constants/med-info-content';
import { CURRENT_INSTANCE } from '@lib/utils';
import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';
import NovartisContactFormButton from './novartis-contact-form-button';

interface INoAnswerResponseProps {
  userQuery?: string;
}

function NoAnswerResponse(props: INoAnswerResponseProps) {
  const { t } = useTranslation();

  return (
    <AnswerMessageContainer>
      <div>
        {t('chat.response.contact_medical_info_long')}
        <br />
        <br />
        <MarkdownRenderer content={MED_INFO_CONTENT[CURRENT_INSTANCE.name].de} />
        <NovartisContactFormButton query={props.userQuery} />
      </div>
    </AnswerMessageContainer>
  );
}

export default NoAnswerResponse;
